import { Route, Routes } from "react-router-dom"
import ReviewLandingPage from "./LandingPage"
import Scan from "./Scan"
import SubmitSuccess from "./Scan/submitSuccess"
import PageNotFound from "../StarInsurance/PageNotFound"
import FileUpload from "./Form/fileUpload"
const StarInsurance = () => {
    return (
        <div className="h-full">
            <Routes>
                <Route path="/" element={<ReviewLandingPage />} />
                <Route path="/review-scan" element={<Scan />} />
                <Route path="/file-upload" element={<FileUpload />} />
                <Route path="/review-thanks" element={<SubmitSuccess />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </div>
    )
}

export default StarInsurance